import React from "react";
import ReactDOM from "react-dom";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { HotTable } from "@handsontable/react";
import { utils } from "~/utils";
import { Icon } from "zina-dogi-react";
import "./oet_history_modal.scss";

export default class OETModalHistory extends React.Component {
    constructor(props) {
        super(props);
        this.data = null;
        this.state = { modal: false };
        this.toggle = this.toggle.bind(this);
    }

    componentDidMount() {
        this.data = getData(this.props.oet_logs);
    }

    componentWillUpdate() {
        this.data = getData(this.props.oet_logs);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        return (
            <div>
                <Button color="primary" onClick={this.toggle} type="button" icon="alarm">
                    History
                </Button>
                <Modal isOpen={this.state.modal} style={{ width: 600 }}>
                    <ModalHeader>OET History Log</ModalHeader>
                    <ModalBody>
                        <HotTable
                            tableClassName="table table-bordered table-striped"
                            data={this.data}
                            rowHeaders={false}
                            height="200"
                            width="100%"
                            stretchH="all"
                            colHeaders={getColHeaders()}
                            columns={getColumns()}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button className="btn-danger" onClick={this.toggle} type="button" name="Close">
                            Close
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

const getColHeaders = () => [" ", "Status", "User", "Date"];

const getColumns = () => {
    const res = [
        {
            data: "step",
            editor: false,
            renderer: function(instance, td, row, col, prop, value, cellProperties) {
                td.className = ["htCenter", "htCenter", "step"].join(" ");
                ReactDOM.render(<Icon icon={value === "back" ? "backward" : value} />, td);
                return td;
            }
        },
        {
            data: "process",
            editor: false,
            className: "htMiddle htMiddle"
        },
        {
            data: "owner",
            editor: false,
            className: "htRight htMiddle"
        },
        {
            data: "date",
            editor: false,
            className: "htRight htMiddle"
        }
    ];
    return res;
};

const getData = data => {
    if (data) {
        return data.map(item => ({
            ...item,
            date: utils.renderDate(item.date),
            step: item.step
        }));
    }
    return [];
};
